import React from 'react';
import { useSession } from '../ui.jsx';

const hkToday = () => new Date(Date.now() + 8 * 3600 * 1000).toISOString().slice(0, 10);

export function defaultFilters() {
  const month = hkToday().slice(0, 7);
  const year = Number(month.slice(0, 4));
  const monthNumber = Number(month.slice(5, 7));
  const from = monthNumber > 5
    ? `${year}-${String(monthNumber - 5).padStart(2, '0')}`
    : `${year - 1}-${String(monthNumber + 7).padStart(2, '0')}`;
  return { from_month: from, to_month: month, unit_id: '', category: '', member_id: '' };
}

/** Month, 單位, 分類 and 成員 filters shared by the 帳簿控制台 screens. */
export default function LedgerFilters({ filters, onChange }) {
  const session = useSession();
  const update = (key, value) => onChange({ ...filters, [key]: value });
  return (
    <div className="grid form" data-testid="ledger-filters">
      <label className="field">
        <span>開始月份</span>
        <input type="month" value={filters.from_month} onChange={(event) => update('from_month', event.target.value)} data-testid="filter-from" />
      </label>
      <label className="field">
        <span>結束月份</span>
        <input type="month" value={filters.to_month} onChange={(event) => update('to_month', event.target.value)} data-testid="filter-to" />
      </label>
      <label className="field">
        <span>單位</span>
        <select value={filters.unit_id} onChange={(event) => update('unit_id', event.target.value)} data-testid="filter-unit">
          <option value="">全部單位</option>
          {session.all_units.map((unit) => <option key={unit.id} value={unit.id}>{unit.name}</option>)}
        </select>
      </label>
      <label className="field">
        <span>分類</span>
        <select value={filters.category} onChange={(event) => update('category', event.target.value)} data-testid="filter-category">
          <option value="">全部分類</option>
          {session.categories.map((category) => <option key={category} value={category}>{category}</option>)}
        </select>
      </label>
      <label className="field">
        <span>成員</span>
        <select value={filters.member_id} onChange={(event) => update('member_id', event.target.value)} data-testid="filter-member">
          <option value="">全部成員</option>
          {session.members.map((member) => <option key={member.id} value={member.id}>{member.display_name}</option>)}
        </select>
      </label>
    </div>
  );
}
